// extracted by mini-css-extract-plugin
module.exports = {"refresh":"Country_refresh__3N-Ex","rotate":"Country_rotate__E38PV"};